export class DataPosition {
  public DossierNum: string;
  public Latitude: number;
  public Longitude: number;
  public Precision: number;
}



// WEBPACK FOOTER //
// ./src/app/dossier/data-position.ts